var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"p-0 m-0 bg-light",attrs:{"id":"app","fluid":""}},[_c('Menu'),_c('router-view'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }